export default __webpack_public_path__ + "video.svg";